import { FaPlay } from "react-icons/fa";
import { FiArrowRight } from "react-icons/fi";

const NewsLetter = () => {
  return (
    <div className="flex flex-wrap -mt-24 bg-primary h-fit sm:h-[250px] rounded-xl py-4 text-slate-100 max-w-7xl mx-auto px-4">
      <div className="flex-1 basis-[20rem]">
        <img
          src="/images/newsletter/newsletter.jpg"
          alt=""
            className="w-[400px] lg:w-[330px] mt-[-15px] lg:ml-[-16px] shadow-md rounded-xl"
           
        />  
      </div>
       
      <div className="flex-1 basis-[16rem] md:basis-[30rem] mt-3 sm:mt-10">
        <div className="text-center sm:text-left">
        <h1 className="text-2xl font-bold capitalize">
  Dive Into the World of Premium Pool Care
</h1>
<p className="mt-2">
  Join our newsletter and stay informed with expert swimming pool maintenance tips, exclusive discounts, and the latest trends in pool design and installations.
</p>

        </div>
        <div className="mt-3">
          <form>
          <div className="justify-center flex-align-center gap-x-2 sm:justify-start">
            <input
              type="email"
              className="px-4 py-1 text-black border-none rounded-md outline-none"
              placeholder="Email address..."
              required
            />
            <button type="submit" className="p-2 rounded-md btn-secondary">
              <FiArrowRight />
            </button>     
           
          </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewsLetter;
